import AbstractProvidedClass from "../shared/AbstractProvidedClass";
import { TIP_BAR_HEIGHT } from "../shared/constants";

export default class TipBar extends AbstractProvidedClass {
    constructor(provider) {
        super(provider);

        this.container = document.createElement('div');
        this.container.className = 'planner-ui-overlay';
        this.container.style.position = 'absolute';
        this.container.style.bottom = '0';
        this.container.style.left = '0';
        this.container.style.right = '0';
        this.container.style.height = TIP_BAR_HEIGHT + 'px';
        this.container.style.backgroundColor = '#fff';
        this.container.style.borderTop = '1px solid #000';
        this.container.style.fontSize = '14px';
        this.container.style.lineHeight = TIP_BAR_HEIGHT + 'px';
        this.container.style.paddingLeft = '10px';
        this.container.style.overflow = 'hidden';
        this.container.style.whiteSpace = 'nowrap';
        this.container.style.boxSizing = 'border-box';
        if (this.touch) {
            this.container.style.overflowX = 'auto';
            this.container.style.WebkitOverflowScrolling = 'touch';
        }
        document.getElementById('p5canvas').appendChild(this.container);
    }

    display() {
        let text = this.tools.currentTool.getTips();
        if (text !== this._lastText) {
            this._lastText = text;
            this.container.textContent = text;
        }
    }
}
